import { render, staticRenderFns } from "./secondHand.vue?vue&type=template&id=b8cdef1e&"
import script from "./secondHand.vue?vue&type=script&lang=ts&"
export * from "./secondHand.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "secondHand.vue"
export default component.exports